import React from 'react';

import DefaultLayout from 'src/layouts/DefaultLayout';
import FcManager from 'src/pages/FcManager';

const Administrator = () => {
  return (
    <>
      <DefaultLayout exact path="/fcManager" component={FcManager} />
      <DefaultLayout exact path="/" component={FcManager} />
    </>
  );
};

export default Administrator;
